import React from "react";
import DataTablePage from "@/components/common/DataTablePage";

export default function ProductsPage() {
  return (
    <DataTablePage
      collection="products"
      eyebrow="Catalog"
      title="Product Performance"
      subtitle="Track product sales manually. Shopify-connected stores see live product performance on the Shopify page."
      emptyMessage="No product data. Connect Shopify to sync your live catalog (see the Shopify page) — or add products manually to track here."
      emptyDefault={{ status: "active", price: 0, sold: 0, revenue: 0, inventory: 0 }}
      columns={[
        { key: "name", label: "Product", type: "text" },
        { key: "roast", label: "Roast", type: "text" },
        { key: "type", label: "Type", type: "text" },
        { key: "price", label: "Price", type: "money" },
        { key: "sold", label: "Sold", type: "number" },
        { key: "revenue", label: "Revenue", type: "money" },
        { key: "inventory", label: "Inventory", type: "number" },
        { key: "status", label: "Status", type: "badge", options: ["best_seller", "active", "slow_moving"] },
      ]}
    />
  );
}
